import React from 'react';
import './EventCard.css'

import location from '../../Assets/Icons/Location.svg'
import Btn from './Btn';

const EventCard = (props) => {
    return ( 
        <div className='EventCard'>
            <div className='ECardDate'>
                <p className='Year'><span className='Day'>{props.Day}</span> <br /> {props.Year}</p>
            </div>
            <img className='ECardImg' src={props.ECardImg} alt="" />

            <div className='ECardLoc'>
                <img src={location} alt="" />
                <p>{props.ECardLoc}</p>
            </div>

            <div className='ECardInfo'>
                <p className='ECardTitle'>{props.ECardTitle}</p>
                <Btn BtnText='Buy Ticket' BtnStyle='BuyBtn'/>
            </div>
        </div>
     );
}
 
export default EventCard;